<template>
  <div style="padding: 4px; min-height: 60vh">
    <div v-if="isCalibracao">
      <v-tabs
        v-model="visao"
        class="abas-padrao"
        background-color="primary"
        color="primary"
      >
        <v-tab @click="atualizarBreadcrumb('Calibracao')">
          Calibração
        </v-tab>
        <v-tab @click="atualizarBreadcrumb('Calibracao', 'Instrumento')">
          Instrumento
        </v-tab>
        <v-tab @click="atualizarBreadcrumb('Calibracao','Procedimento Eletronico')">
          Procedimento Eletrônico
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="visao">
        <v-tab-item>
          <div
            v-for="(arquivo, key) in files?.arquivos"
            :key="key"
            class="mt-4"
          >
            <div
              class="d-flex mb-2 mt-2"
              style="gap: 8px"
            >
              <i
                class="pi pi-file-pdf"
                style="font-size: 20px !important"
              />
              <a @click="openFile(arquivo, files.nomePasta)">{{
                arquivo
              }}</a>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div v-if="!buscarPastaCalibracao('Instrumento')?.arquivos?.length">
            Nenhum arquivo ou pasta existente...
          </div>
          <div
            v-for="(item, key) in buscarPastaCalibracao('Instrumento')?.arquivos"
            :key="key"
            class="mt-4"
          >
            <div
              class="d-flex mb-2"
              style="margin-right: 8px"
            >
              <i
                class="pi pi-file-pdf mr-2"
                style="font-size: 20px !important"
              />
              <a @click="openFile(item.arquivo, item.caminhoArquivo)">{{
                item.arquivo
              }}</a>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div v-if="!buscarPastaCalibracao('Procedimento-Eletronico')?.arquivos?.length">
            Nenhum arquivo ou pasta existente...
          </div>
          <div
            v-for="(item, key) in buscarPastaCalibracao('Procedimento-Eletronico')?.arquivos"
            :key="key"
            class="mt-4"
          >
            <div
              class="d-flex mb-2"
              style="margin-right: 8px"
            >
              <i
                class="pi pi-file-pdf mr-2"
                style="font-size: 20px !important"
              />
              <a @click="openFile(item.arquivo, item.caminhoArquivo)">{{
                item.arquivo
              }}</a>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-else>
      <div
        v-for="(arquivo, key) in files.arquivos"
        :key="key"
        class="mt-4"
      > 
        <h5 v-if="isCalibracao">
          Arquivos do
          {{
            key == 0
              ? `Instrumento: ${$store.state.instrumentoCalibracao}`
              : `Procedimento Eletronico: ${$store.state.procedimentoEletronicoCalibracao}`
          }}
        </h5>
        <div
          class="d-flex mb-2"
          style="margin-right: 8px"
        >
          <i
            class="pi pi-file-pdf mr-2"
            style="font-size: 20px !important"
          />
          <a @click="openFile(arquivo, files.nomePasta)">{{ arquivo }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AjudaService from '@common/services/AjudaService';

export default {
  name: 'ListFiles',
  data() {
    return {
      files: {},
      module: '',
      nomePasta: '',
      pastas: [],
      visao: 0,
    };
  },
  computed: {
    instrumentoCalibracao() {
      return this.$store.state?.instrumentoCalibracao;
    },
    procedimentoEletronicoCalibracao() {
      return this.$store.state?.procedimentoEletronicoCalibracao;
    },
    hasMain() {
      return !this.$route.params?.moduleName?.length;
    },
    isCalibracao() {
      console.log("moduleName", this.$route.params?.moduleName)
      return this.$route.params?.moduleName == 'calibracao';
    },
  },
  mounted() {
    if (this.hasMain) {
      this.getFolders();
    } else {
      this.getFilesList();
    }
  },
  methods: {
    buscarPastaCalibracao(nomePasta){
      return this.files?.pastas?.find(pasta => pasta.nomePasta === nomePasta);
    },
    atualizarBreadcrumb(...pastas) {
      this.$emit('updateBreadcrumb', pastas);
    },
    toFolder(item, prefix) {
      this.$router.push({
        name: 'ajuda',
        params: { moduleName: prefix },
      });
      this.getFilesList();
    },
    pegarPalavraAposPontoEVirgula(str) {
      const posicao = str.indexOf('\\');

      if (posicao !== -1) {
        return str.substring(posicao + 1).trim();
      } else {
        return str;
      }
    },
    openFile(item, nomePasta) {
      this.$store.dispatch('Layout/iniciarCarregamento');
      AjudaService.downloadFile(item, nomePasta)
        .then(res => {
          this.baixarArquivo(res.data, item)
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    baixarArquivo(base64Content, nomeArquivo){
      // Decodifica o base64 para bytes
      const binaryString = atob(base64Content);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
      }

      // Cria um blob a partir dos bytes
      const blob = new Blob([bytes], { type: 'application/octet-stream' }); // Altere o tipo conforme necessário

      // Cria uma URL para o blob
      const url = URL.createObjectURL(blob);

      // Cria um link de download
      const a = document.createElement('a');
      a.href = url;
      a.download = nomeArquivo; // Substitua 'file.ext' pelo nome e extensão do arquivo desejado
      document.body.appendChild(a);
      a.click();

      // Remove o link de download
      document.body.removeChild(a);

      // Libera a URL do blob
      URL.revokeObjectURL(url);
    },
    async getFolders() {
      const res = await AjudaService.getFoldersMain();
      this.pastas = res.data;
    },
    async getFilesList() {
      this.$store.dispatch('Layout/iniciarCarregamento');
      this.module = this.$route.params?.moduleName;
      this.pastas = [];

      try {
        if (this.module === 'calibracao') {
          this.calibracaoId = this.$route.query?.calibracaoId || null;
          // this.filesGerais = await AjudaService.getListFiles('calibracao');
          this.files = await AjudaService.getCalibrationFiles(
            this.calibracaoId
          );
          console.log(this.files)
        } else {
          this.files = await AjudaService.getDocumentsList(this.module);
        }

        this.$emit('updateBreadcrumb', [this.module]);
      } catch (err) {
        Window.App.toastErro(err.message);
      } finally {
        this.$store.dispatch('Layout/terminarCarregamento');
      }
    },
  },
};
</script>
